import { SectionCard } from '@/components/SectionCard'
import { ItemStats } from '@/features/items/components/ItemStats'
import { Item } from '@/features/items/types/item'
import { useTranslation } from 'react-i18next'
import { Department } from '../types/department'

export function DepartmentItemList({ department, items }: { department?: Department; items?: Item[] }) {
  const { t } = useTranslation()
  return (
    <SectionCard data-testid="department-equipment-list" title={t('common.equipment')}>
      {items?.length === 0 ? (
        <p className="py-4 text-center text-xs text-muted-foreground">{t('department.noEquipment')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {items?.map(item => {
            const title = item.productName || `${item.productBrand} ${item.productModel}`
            return (
              <ItemStats
                key={item.id}
                title={title}
                subtitle={item.serialNumber}
                status={item.status}
                days={item.daysSinceLastStatusChange}
              ></ItemStats>
            )
          })}
        </div>
      )}
    </SectionCard>
  )
}
